angular
    .module('tradersyard')
    .directive('endorseNode', [
        '$parse',
        'graph-endorse-factory',
        '$timeout',
        function ($parse, $client, $timeout) {
            return {
                scope: true,
                link: function ($scope, $element, $attr) {
                    var client = $client;

                    $scope.nodes = [];
                    $scope.entry = undefined;
                    $scope.entryId = 0;
                    $scope.entryIm = false;
                    $scope.entryCount = 5;

                    $timeout(function () {
                        $scope.entry = $parse($attr.entry)($scope);
                        $scope.entryId = $parse($attr.entryId)($scope);
                        $scope.entryIm = $parse($attr.entryIm)($scope);

                        client = client.entry($parse($attr.entry)($scope), $parse($attr.entryId)($scope));

                        if ($attr.entryCount) {
                            $scope.entryCount = $parse($attr.entryCount)($scope);
                        }
                    });

                    var endorseTag = function (tag) {
                        client.endorse(tag.id).then(function (response) {
                            if (response.data.state === 0) {
                                tag.im_endorse = true;
                                ++tag.endorses;
                            }
                        });
                    };

                    var renounceTag = function (tag) {
                        client.renounce(tag.id).then(function (response) {
                            if (response.data.state === 0) {
                                tag.im_endorse = false;
                                --tag.endorses;
                            }
                        });
                    };

                    $scope.switchEndorse = function (tag) {
                        if (tag.im_endorse) {
                            renounceTag(tag);
                        } else {
                            endorseTag(tag);
                        }
                    };
                },
            };
        },
    ])
    .directive('endorseForm', [
        '$parse',
        'graph-endorse-factory',
        '$timeout',
        'graph-search-factory',
        '$window',
        function ($parse, $client, $timeout, $search, $window) {
            return {
                link: function ($scope, $element, $attr) {
                    var client = $client,
                        params = {
                            page: 0,
                        };

                    $scope.tagForm = { name: '' };

                    $scope.nodes = [];

                    $timeout(function () {
                        client = client.entry($parse($attr.entry)($scope), $parse($attr.entryId)($scope));

                        $scope.query();
                    });

                    $scope.suggestion = {
                        isShown: false,
                        proceed: true,
                        nodes: [],
                        search: function () {
                            $scope.suggestion.proceed = false;

                            $search
                                .entry('endorse.tags')
                                .search({
                                    params: {
                                        q: $scope.tagForm.name,
                                    },
                                })
                                .then(function (response) {
                                    if (response.data.state === 0) {
                                        $scope.suggestion.nodes = response.data.data;
                                    }

                                    $scope.suggestion.proceed = true;

                                    if ($scope.$root.$$phase != '$apply' && $scope.$root.$$phase != '$digest') {
                                        $scope.$apply();
                                    }
                                });
                        },
                    };

                    function isElement(obj) {
                        try {
                            //Using W3 DOM2 (works for FF, Opera and Chrom)
                            return obj instanceof HTMLElement;
                        } catch (e) {
                            //Browsers not supporting W3 DOM2 don't have HTMLElement and
                            //an exception is thrown and we end up here. Testing some
                            //properties that all elements have. (works on IE7)
                            return (
                                typeof obj === 'object' &&
                                obj.nodeType === 1 &&
                                typeof obj.style === 'object' &&
                                typeof obj.ownerDocument === 'object'
                            );
                        }
                    }

                    angular.element($window).bind('click', function ($event) {
                        var $$element = angular.element(document.querySelector('#endorse-search-form'));
                        var node = angular.element($event.target);
                        var target = false;

                        while (node[0] !== undefined) {
                            if (isElement(node[0]) && $$element[0].isEqualNode(node[0])) {
                                target = true;
                                break;
                            }

                            node = node.parent();
                        }

                        if ($scope.suggestion.isShown !== target) {
                            $scope.suggestion.isShown = target;

                            if ($scope.$root.$$phase != '$apply' && $scope.$root.$$phase != '$digest') {
                                $scope.$apply();
                            }
                        }
                    });

                    var t;

                    $scope.$watch(
                        function () {
                            return $scope.tagForm.name;
                        },
                        function (val, $nval) {
                            if (val !== $nval) {
                                wait = 1;
                                if (t) $timeout.cancel(t);

                                t = $timeout(function () {
                                    $scope.suggestion.search();
                                }, 0);
                            }
                        }
                    );

                    $scope.query = function (next) {
                        ++params.page;
                        client.tags({ params: params }).then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.nodes = $scope.nodes.concat(response.data.data);

                                if (next) next();
                            }
                        });
                    };

                    $scope.create = function () {
                        client.create($scope.tagForm).then(function (response) {
                            if (response.data.state === 0) {
                                var ids = $scope.nodes.map(function (node) {
                                    return node.id;
                                });
                                if (ids.indexOf(response.data.data.id) < 0) {
                                    $scope.nodes.unshift(response.data.data);
                                }

                                $scope.tagForm = { name: '' };
                            }
                        });
                    };

                    $scope.delete = function (node, index) {
                        client.delete(node.id).then(function (response) {
                            if (response.data.state === 0) {
                                $scope.nodes.splice(index, 1);
                            }
                        });
                    };
                },
            };
        },
    ]);
